<template>
    <div class="app-promo-card">
        <div class="promo-header">
            <div class="app-icon">
                <img
                    src="@/assets/redchirp-square-large.png"
                    alt="RedChirp App"
                    @error="handleImageError"
                />
                <div v-if="image_error" class="app-icon-fallback">
                    <v-icon color="white">mdi-glass-wine</v-icon>
                </div>
            </div>
            <div class="promo-title-area">
                <h4 class="promo-title">RedChirp App</h4>
                <p class="promo-subtitle">Your wine club, simplified</p>
            </div>
        </div>

        <div class="promo-features">
            <div
                v-for="(feature, index) in features"
                :key="index"
                class="feature-item"
            >
                <v-icon small class="feature-icon">{{ feature.icon }}</v-icon>
                <span>{{ feature.text }}</span>
            </div>
        </div>

        <div class="promo-cta">
            <button class="download-btn" @click="$emit('download')">
                <svg class="apple-logo" viewBox="0 0 24 24" aria-hidden="true">
                    <path fill="currentColor" d="M18.71,19.5C17.88,20.74 17,21.95 15.66,21.97C14.32,22 13.89,21.18 12.37,21.18C10.84,21.18 10.37,21.95 9.1,22C7.79,22.05 6.8,20.68 5.96,19.47C4.25,17 2.94,12.45 4.7,9.39C5.57,7.87 7.13,6.91 8.82,6.88C10.1,6.86 11.32,7.75 12.11,7.75C12.89,7.75 14.37,6.68 15.92,6.84C16.57,6.87 18.39,7.1 19.56,8.82C19.47,8.88 17.39,10.1 17.41,12.63C17.44,15.65 20.06,16.66 20.09,16.67C20.06,16.74 19.67,18.11 18.71,19.5M13,3.5C13.73,2.67 14.94,2.04 15.94,2C16.07,3.17 15.6,4.35 14.9,5.19C14.21,6.04 13.07,6.7 11.95,6.61C11.8,5.46 12.36,4.26 13,3.5Z" />
                </svg>
                <span>Download the App</span>
            </button>

            <button class="start-new-order-btn" @click="$emit('start-new-order')">
                Start new order
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppPromoCard',

    props: {
        customer_name: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            image_error: false,
            features: [
                { icon: 'mdi-truck-delivery', text: 'Track all your wine shipments' },
                { icon: 'mdi-bell-outline', text: 'Get alerts for club customizations' },
                { icon: 'mdi-star-outline', text: 'Early access to new allocations' },
                { icon: 'mdi-calendar-check', text: 'Manage club memberships easily' },
                { icon: 'mdi-airplane', text: 'One-click vacation hold' }
            ]
        };
    },

    methods: {
        handleImageError() {
            this.image_error = true;
        }
    },
};
</script>

<style lang="scss" scoped>
.app-promo-card {
    background: #fff;
    border-radius: 1rem;
    border-bottom-left-radius: 0.25rem;
    overflow: hidden;
    border: 1px solid #e8e0d5;
    transition: all 0.2s ease;
}

.promo-header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem;
    border-bottom: 1px solid #e8e0d5;
}

.app-icon {
    position: relative;
    width: 3rem;
    height: 3rem;
    border-radius: 0.25rem;
    overflow: hidden;
    flex-shrink: 0;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}

.app-icon-fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);
}

.promo-title-area {
    flex: 1;
    min-width: 0;
}

.promo-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
}

.promo-subtitle {
    font-size: 0.8rem;
    margin: 0;
}

.promo-features {
    padding: 0.75rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.8rem;
}

.feature-icon {
    color: #676767;
}

.promo-cta {
    padding: 0.5rem 1rem 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.download-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.75rem 1rem;
    background: #000;
    border: none;
    border-radius: 0.5rem;
    color: white;
    font-size: 0.85rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #333;
    }

    &:active {
        transform: scale(0.98);
    }
}

.apple-logo {
    width: 1rem;
    height: 1rem;
}

.start-new-order-btn {
    width: 100%;
    padding: 0.5rem 0.5rem;
    background: transparent;
    border: none;
    color: var(--brand-primary-light);
    font-size: 0.8rem;
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
        color: var(--brand-primary);
    }
}
</style>
